// extracted by mini-css-extract-plugin
export var active = "_21-7";
export var backButton = "_21-6";
export var clone = "_21-c";
export var collapseBar = "_21-g";
export var collapseMode = "_21-i";
export var dragHandle = "_21-a";
export var dropdownIcon = "_21-e";
export var hidden = "_21-o";
export var iconContainer = "_21-l";
export var iconSwapper = "_21-n";
export var navItem = "_21-4";
export var navItemIcon = "_21-d";
export var navProfile = "_21-5";
export var notificationDot = "_21-m";
export var optionsContainer = "_21-f";
export var primaryNav = "_21-0";
export var primaryTab = "_21-j";
export var secondaryNav = "_21-1";
export var selected = "_21-k";
export var settingsNav = "_21-2";
export var settingsNavItems = "_21-3";
export var show = "_21-b";
export var sideNav = "_21-h";
export var teamItem = "_21-8";
export var userProfileItem = "_21-9";